export default __webpack_public_path__ + "static/rec-2014-5d832582b7f04d4c23af1d94242b2973.png";